import IconsCommon from './containers/iconsCommon'

export {default as IconsCommonLayout} from './components/iconsCommonLayout'

export default IconsCommon
